import { combineReducers } from 'redux';

import data from './data';
import options from './options';

export default combineReducers({ data, options });
